export enum StationAccessType {
  AccessTypePublic = 0,
  AccessTypeLimited = 1,
  AccessTypePrivate = 2,
}
